import { ITextAndImageCardBlock } from '../fragments/textAndImageCardBlock';

export function findMemberDayEditorialCard(
  cards: Array<ITextAndImageCardBlock>,
  tagId: string = 'livliFamilyMemberOffer',
): ITextAndImageCardBlock | null {
  if (!Array.isArray(cards)) {
    return null;
  }
  for (const card of cards) {
    const tags = card?.cardLink?.contentfulMetadata?.tags;
    if (Array.isArray(tags) && tags.some((tag) => tag.id === tagId)) {
      return card;
    }
  }
  return null;
}
